import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import { getAssetPath, sanitizer } from "@commonUtils"

import { isDwebUrl } from "@lib/urlMatchUtility"

import ImageLoader from "@components/ImageLoader/ImageLoader"
import Button from "@components/Button/Button"

import ConditionalLink from "@wrappers/ConditionalLink/ConditionalLink"

import css from "./OrderPlaced.scss"

const informationIcon = getAssetPath("svgs/icons/information_18px_primary.svg")

export const OrderPlaced = ({ col, header, image, animated, animationCompleteHandler, internalData }) => {
    const [animationComplete, setAnimationComplete] = useState(false)
    useEffect(() => {
        setTimeout(() => {
            animationCompleteHandler?.()
            setAnimationComplete(true)
        }, 1500)
    }, [])

    return (
        <div className={[css.orderContainer, animated ? css.animatedOrderContainer : ""].join(" ")}>
            <div
                className={[
                    `col-${col}`,
                    animated ? css.animatedCoralContainer : "",
                    css.coralContainer,
                ].join(" ")}
            >
                <div className={`flexColumn alignCenter ${css.containerJigsawImage}`}>
                    <div className={[css.containerIcon, animated ? css.animatedContainerIcon : ""].join(" ")}>
                        {image && <ImageLoader src={image?.url} {...image} />}
                    </div>
                    <div
                        className={`marginTop-16 ${css.whiteText} ${
                            animated ? css.animatedText : ""
                        } l2SemiBold`}
                    >
                        {header}
                    </div>
                </div>
            </div>
            {animationComplete && internalData && (
                <div className="widget-container marginBoth-8 flexColumn justifyCenter">
                    <div className={`col-${col} marginTop-8 textCenter`}>
                        {internalData.internalSubHeader && (
                            <div
                                className={`${internalData.internalHeader ? "marginTop-8" : ""} bodyRegular`}
                                dangerouslySetInnerHTML={{
                                    __html: sanitizer(internalData.internalSubHeader),
                                }}
                            />
                        )}
                        {internalData.internalHeader && (
                            <div className="marginTop-4 flex alignCenter justifyCenter">
                                <span className="l4SemiBold">{internalData.internalHeader}</span>
                                {internalData.internalHandler && (
                                    <span
                                        className={`${css.marginLeft4} flex`}
                                        onClick={internalData.internalHandler}
                                    >
                                        <ImageLoader src={informationIcon} />
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                    {(internalData.primaryCTA || internalData.secondaryCTA) && (
                        <div className="flex marginTop-16 justifyCenter">
                            {internalData.secondaryCTA?.label && (
                                <ConditionalLink
                                    to={internalData.secondaryCTA.url}
                                    isExternal={
                                        internalData.secondaryCTA.url &&
                                        !isDwebUrl(internalData.secondaryCTA.url)
                                    }
                                    onClick={(e) => internalData.secondaryCTA.ctaHandler?.(e)}
                                >
                                    <div className={`col-${internalData.secondaryCTA.span || 4}`}>
                                        <Button
                                            as="div"
                                            type="secondary"
                                            label={internalData.secondaryCTA.label}
                                        />
                                    </div>
                                </ConditionalLink>
                            )}
                            {internalData.primaryCTA?.label && (
                                <ConditionalLink
                                    to={internalData.primaryCTA.url}
                                    isExternal={
                                        internalData.primaryCTA.url && !isDwebUrl(internalData.primaryCTA.url)
                                    }
                                    onClick={(e) => internalData.primaryCTA?.ctaHandler?.(e)}
                                >
                                    <div className={`col-${internalData.primaryCTA.span || 4}`}>
                                        <Button as="div" label={internalData.primaryCTA.label} />
                                    </div>
                                </ConditionalLink>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

OrderPlaced.defaultProps = {
    animated: true,
}

OrderPlaced.propTypes = {
    col: PropTypes.number.isRequired,
    header: PropTypes.string.isRequired,
    image: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
        width: PropTypes.string,
        height: PropTypes.string,
    }),
    animated: PropTypes.bool,
    animationCompleteHandler: PropTypes.func,
    internalData: PropTypes.shape({
        internalSubHeader: PropTypes.string,
        internalHeader: PropTypes.string,
        internalHandler: PropTypes.func,
        primaryCTA: PropTypes.shape({
            label: PropTypes.string,
            url: PropTypes.string,
            ctaHandler: PropTypes.func,
            span: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        secondaryCTA: PropTypes.shape({
            label: PropTypes.string,
            url: PropTypes.string,
            ctaHandler: PropTypes.func,
            span: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    }),
}

export default OrderPlaced
